import React from 'react'
import { useTranslation } from 'react-i18next'
import { AlternativeAutoComplete } from 'common/form/autoComplete/_alternativeAutoComplete'
import { Option } from 'common/form/autoComplete/_option'
import { LINK_STATUS } from '../../interfaces/_constants'
import useCustomerFilterForm from '../../hooks/useCustomerFilterForm'

export const CustomerType = () => {
  const { t } = useTranslation()
  const { customerType } = useCustomerFilterForm()
  return (
    <AlternativeAutoComplete
      className="customer-filter-form__input-wide"
      // main input
      inputProps={{
        categoryList: [], // menu list in category dropdown
        categoryValue: { name: 'Loại khách hàng', value: '' }, // if not exist this value -> default category: categoryList[0]
        categoryWidth: 120,
        placeholder: t('Chọn loại khách hàng'),
        readOnly: true,
        value: t(customerType?.value?.name) || '',
        onIconClick: () => customerType.onChange(null),
      }}
      hideSearchBar={true}
    >
      {LINK_STATUS?.map(item => (
        <Option
          key={item.value}
          className="customer-filter-form__option-text"
          data-active={item.value === customerType?.value?.value}
          onClick={() => customerType.onChange(item)}
        >
          {t(item.name)}
        </Option>
      ))}
    </AlternativeAutoComplete>
  )
}

